import {combineReducers} from 'redux';

import searchHistory from './SearchHistoryReducer';

const GlobalSearchReducer = combineReducers({
  searchHistory
});

export default GlobalSearchReducer;



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearch/reducer/index.js